import { Component, OnInit, forwardRef } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TagsComponent),
  multi: true
};

@Component({
  selector: 'swb-tags',
  templateUrl: './tags.component.html',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class TagsComponent extends FormEditorBase implements OnInit {
  private _onModelChanged: Function;
  public value: Array<any> = [];

  ngOnInit() {
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: Array<any>) {
    this.value = value;
  }

  public toggleTag(tag: any): void {
    const index = this.value.findIndex(valTag => valTag.id === tag.id);
    if (index > -1) {
      this.value.splice(index, 1);
    } else {
      this.value.push(tag);
    }
    this._onModelChanged(this.value);
  }

  public isSelected(id: string) {
    return this.value.some(entity => entity.id === id);
  }

}
